import React, { type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Link } from 'mailup-web-components'

import { evalCondition } from 'mailup-react-helpers'

import { panelEditRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

import { recipientEngagementState } from 'Pages/RecipientsList/recoil/state/engagemet'

import EngagementUpsellingView from 'Pages/RecipientsList/components/results/EngagementUpsellingView'
import EngagementView from 'Pages/RecipientsList/components/results/EngagementView'

interface ItemEngagementProps {
  id: number
  isMainItem?: boolean
}

const ItemEngagement: FC<ItemEngagementProps> = ({ id, isMainItem }) => {
  const hasDelStats: boolean = evalCondition('co:DELSTATS')

  const score = useRecoilValue(recipientEngagementState(id))

  const panelOpen = useRecoilCallback(panelEditRecipientOpenCallback, [])

  const handleClick = (e: React.MouseEvent<HTMLLinkElement>): void => {
    e.stopPropagation()

    void panelOpen(id)
  }

  if (isMainItem === true) {
    if (hasDelStats) {
      return (
        <Link onClick={handleClick} data-mu-test="item-engagement">
          <EngagementView score={score} />
        </Link>
      )
    }

    return (
      <Link onClick={handleClick} data-mu-test="item-engagement">
        <EngagementUpsellingView />
      </Link>
    )
  }

  if (hasDelStats) {
    return <EngagementView score={score} />
  }

  return <EngagementUpsellingView />
}

export default ItemEngagement
